import requests from './httpService';

const BillDetailsPaymentServices = {
	billdetailspaymentRequestList: async (body) => {
		return requests.post(`/billPayment/payment-list`, body);
	},
	updatebilldetailspayment: async (id, body) => {
	// console	.log(id,body);
		return requests.put(`/billPayment/bill-details-payment/${id}`, body);
	},
	updateBillReadypayment: async (body) => {
		return requests.put(`/billPayment/bill-payment-bulk`, body);
	},
};

export default BillDetailsPaymentServices;
